const advantages = [
  {
    icon: 'ri-cpu-line',
    title: '超大规模并行',
    desc: '2048个独立核心协同工作，采用先进片上网络互联，支持大规模数据并行处理，单芯片提供PetaFLOPS级算力。',
    stat: '2048',
    statLabel: '计算核心',
  },
  {
    icon: 'ri-flashlight-fill',
    title: '极致能效比',
    desc: '先进制程工艺结合动态功耗管理，每瓦性能较上一代提升2.3倍，助力绿色数据中心建设。',
    stat: '2.3x',
    statLabel: '能效提升',
  },
  {
    icon: 'ri-shield-check-fill',
    title: '硬件级安全隔离',
    desc: '支持可信执行环境与缓存分区技术，在多租户云环境中实现硬件级安全隔离，防范侧信道攻击。',
    stat: '64GB',
    statLabel: '安全Enclave',
  },
  {
    icon: 'ri-stack-fill',
    title: '3D堆叠集成',
    desc: '采用3D芯片堆叠与HBM3高带宽内存，实现逻辑与存储的垂直紧密耦合，带宽突破TB/s级别。',
    stat: '6.4TB/s',
    statLabel: '内存带宽',
  },
];

export default function AdvantagesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 bg-primary-50 text-primary-600 text-xs font-medium rounded-full mb-4">
            核心技术优势
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            重新定义并行计算边界
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            2048核处理器在架构设计、能效管理、安全保障和集成密度四个维度实现全面突破
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {advantages.map((item) => (
            <div
              key={item.title}
              className="group relative bg-background-100 rounded-lg p-6 transition-all duration-300 hover:bg-background-100/80"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 mb-5 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-lg text-accent-600`}></i>
              </div>

              <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-5">
                {item.desc}
              </p>

              <div className="pt-4 border-t border-background-200/70">
                <span className="text-2xl font-heading font-bold text-primary-500">
                  {item.stat}
                </span>
                <span className="text-xs text-foreground-400 ml-2">
                  {item.statLabel}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}